import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import request from '../helpers/request';

const getHouses = async (values) => {
  return await request.get(
    `/TransportPermit/houses`,
    values,
    'При получении списка домов произошла ошибка'
  );
};

const useHouseAvailableQuery = (values, options) =>
  useQuery(queryKeys.housesAvailable(values), () => getHouses(values), options);

export default useHouseAvailableQuery;
